var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison-grid",staticStyle:{"width":"100%"}},[_c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"320px"},attrs:{"columnDefs":_vm.columnDefs,"defaultColDef":_vm.defaultColDef,"rowData":_vm.items,"rowSelection":"single"},on:{"grid-ready":_vm.onGridReady,"row-clicked":_vm.onRowClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }